import axios, { AxiosError, CancelTokenSource } from 'axios';
import { getToken, handleRequestErrors } from './api';
import { LOGISTIC_SERVICE_STATUS_NAME } from '../types/services';

const axiosApiInstance = axios.create();
let cancelTokenToConfirmed: CancelTokenSource;
let cancelTokenConfirmed: CancelTokenSource;
let cancelTokenInProcess: CancelTokenSource;
let cancelTokenActive: CancelTokenSource;
let cancelTokenDelayed: CancelTokenSource;
let cancelTokenDelivered: CancelTokenSource;
let cancelTokenCancelled: CancelTokenSource;

export async function apiGetWithCancelationSL<T, U>(url: string, logisticStatus: string, options?: T): Promise<U> {
  const { CANCELLED, CONFIRMED, ACTIVE, DELIVERED, INPROCESS, DELAYED, TOCONFIRMED } = LOGISTIC_SERVICE_STATUS_NAME;
  if (logisticStatus === TOCONFIRMED) {
    if (cancelTokenToConfirmed) cancelTokenToConfirmed.cancel('Solicitud cancelada');
    cancelTokenToConfirmed = axios.CancelToken.source();
  }
  if (logisticStatus === CONFIRMED) {
    if (cancelTokenConfirmed) cancelTokenConfirmed.cancel('Solicitud cancelada');
    cancelTokenConfirmed = axios.CancelToken.source();
  }
  if (logisticStatus === INPROCESS) {
    if (cancelTokenInProcess) cancelTokenInProcess.cancel('Solicitud cancelada');
    cancelTokenInProcess = axios.CancelToken.source();
  }
  if (logisticStatus === ACTIVE) {
    if (cancelTokenActive) cancelTokenActive.cancel('Solicitud cancelada');
    cancelTokenActive = axios.CancelToken.source();
  }
  if (logisticStatus === DELAYED) {
    if (cancelTokenDelayed) cancelTokenDelayed.cancel('Solicitud cancelada');
    cancelTokenDelayed = axios.CancelToken.source();
  }
  if (logisticStatus === DELIVERED) {
    if (cancelTokenDelivered) cancelTokenDelivered.cancel('Solicitud cancelada');
    cancelTokenDelivered = axios.CancelToken.source();
  }
  if (logisticStatus === CANCELLED) {
    if (cancelTokenCancelled) cancelTokenCancelled.cancel('Solicitud cancelada');
    cancelTokenCancelled = axios.CancelToken.source();
  }
  try {
    const token = await getToken();
    const headers = {
      'Content-Type': 'application/json',
      Authorization: token
    };
    const getCancelToken = () => {
      switch (logisticStatus) {
        case TOCONFIRMED:
          return cancelTokenToConfirmed?.token;
        case CONFIRMED:
          return cancelTokenConfirmed?.token;
        case INPROCESS:
          return cancelTokenInProcess?.token;
        case ACTIVE:
          return cancelTokenActive?.token;
        case DELAYED:
          return cancelTokenDelayed?.token;
        case DELIVERED:
          return cancelTokenDelivered?.token;
        case CANCELLED:
          return cancelTokenCancelled?.token;
        default:
          return undefined;
      }
    };
    const { data } = await axiosApiInstance.get<U>(url, {
      ...options,
      headers,
      cancelToken: getCancelToken()
    });
    return data;
  } catch (error) {
    handleRequestErrors(error as AxiosError);
    throw error;
  }
}
